import { Component, Input, OnInit } from '@angular/core';
import { ToastType } from './models/toast-type.enum';
import { Toast } from './models/toast.model';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'toast',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

	@Input() public toast: Toast;

	constructor() { }

	ngOnInit(): void {
	}

	public getClassByType(): string {
		let className = '';
		switch (this.toast.type) {
			case ToastType.Error: className = 'error'; break;
			case ToastType.Success: className = 'success'; break;
			case ToastType.Warning: className = 'warning'; break;
			case ToastType.Info: className = 'info'; break;
			default: break;
		}

		return className;
	}
}
